import React from 'react';
import Avatar from '@atlaskit/avatar';
import { components } from '@atlaskit/select';
import { N20, N700 } from '@atlaskit/theme/colors';
import { SelectOptionContainer, SelectOptionLabelValueWrapper } from './styled';
export const formOption = formDetails => ({
  value: formDetails.projectFormId,
  label: formDetails.name
});
export const projectOption = project => ({
  value: project.id,
  label: `${project.name} (${project.key})`,
  avatar: project.avatar.large,
  projectType: project.projectType
});
export const sortSelectOption = (a, b) => a.label.localeCompare(b.label);
export const typeOption = formDetails => {
  var _formDetails$requestT, _formDetails$requestT2, _formDetails$requestT3, _formDetails$requestT4;
  return {
    value: `${formDetails.issueType.id}-${(_formDetails$requestT = formDetails.requestType) === null || _formDetails$requestT === void 0 ? void 0 : _formDetails$requestT.id}`,
    label: ((_formDetails$requestT2 = formDetails.requestType) !== null && _formDetails$requestT2 !== void 0 ? _formDetails$requestT2 : formDetails.issueType).name,
    avatar: ((_formDetails$requestT3 = formDetails.requestType) !== null && _formDetails$requestT3 !== void 0 ? _formDetails$requestT3 : formDetails.issueType).icon,
    issueTypeId: formDetails.issueType.id,
    requestTypeId: (_formDetails$requestT4 = formDetails.requestType) === null || _formDetails$requestT4 === void 0 ? void 0 : _formDetails$requestT4.id
  };
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

export const renderOption = () => ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement(Option, {
  data: props.data
}, children));
export const renderSingleValue = () => ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(components.SingleValue, props, /*#__PURE__*/React.createElement(Option, {
  data: props.data
}, children));
const Option = ({
  data,
  children
}) => /*#__PURE__*/React.createElement(SelectOptionContainer, null, /*#__PURE__*/React.createElement(Avatar, {
  appearance: "square",
  src: data.avatar,
  size: "xsmall"
}), /*#__PURE__*/React.createElement(SelectOptionLabelValueWrapper, null, children));
export const selectStyles = () => ({
  control: (provided, state) => {
    if (state.hasValue || state.isFocused) {
      return {
        ...provided,
        backgroundColor: `var(--ds-background-selected, ${N700})`,
        border: 0,
        ':hover': {
          backgroundColor: `var(--ds-background-selected, ${N700})`
        }
      };
    }
    return provided;
  },
  dropdownIndicator: (provided, state) => {
    if (state.hasValue || state.isFocused) {
      return {
        ...provided,
        color: `var(--ds-text-selected, ${N20})`,
        ':hover': {
          color: `var(--ds-text-selected, ${N20})`
        }
      };
    }
    return provided;
  },
  input: provided => ({
    ...provided,
    color: `var(--ds-text, ${N20})`
  }),
  placeholder: (provided, state) => {
    if (state.hasValue || state.isFocused) {
      return {
        ...provided,
        color: `var(--ds-text-selected, ${N20})`,
        whiteSpace: 'nowrap'
      };
    }
    return provided;
  },
  singleValue: (provided, state) => {
    if (state.hasValue) {
      return {
        ...provided,
        color: `var(--ds-text-selected, ${N20})`
      };
    }
    return provided;
  }
});

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// Copied (and simplified) from 'paginated-picker' for consistency:
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
export const formatLabel = (label, value) => {
  if (!value) {
    return label;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, label, ":"), " ", value.label);
};